import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import LoadingScreen from './LoadingScreen'; // ✅ use this one





// Loading fallback to prevent black screen

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <LoadingScreen />
    </Suspense>
  </React.StrictMode>
);

const mountApp = () => {
  root.render(
    <React.StrictMode>
      <Suspense fallback={<LoadingScreen />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
};

// The dedicated OIDC callback route owns code/state processing.
mountApp();
